import { HeaderUpdateButtonAndInSaleSwitch } from "@/components/features/items/edit/_shared/ui/components/header/header-update-button-and-in-sale-switch";

import { useActions } from "./hooks/use-actions";

export const HeaderActions = () => {
	const {
		isValid,
		onUpdate, //
		inSale,
		handleChangeInSale,
		handleClickPreviewButton,
	} = useActions();

	return (
		<HeaderUpdateButtonAndInSaleSwitch
			updateButton={{
				isValid: isValid,
				handleClick: onUpdate,
			}}
			inSaleSwitch={{
				inSale,
				handleChangeInSale,
			}}
			previewButton={{
				isValid: isValid,
				handleClick: handleClickPreviewButton,
			}}
		/>
	);
};
